import {
  UseMutationOptions,
  UseQueryOptions,
  useMutation,
  useQuery,
} from "@tanstack/react-query"
import { AxiosError } from "axios"
import api from "services/api"
import { ISendSignUpForm } from "./use-form"

interface VerifyTokenRequestBody {
  token: string
}

export function useVerifyTokenValidity(
  params: VerifyTokenRequestBody,
  config?: UseQueryOptions<unknown, AxiosError>
) {
  return useQuery<unknown, AxiosError>(
    [
      "operation",
      "administration",
      "members",
      "external",
      "check-verification-token",
      params,
    ],
    () =>
      api.post(
        "operation/administration/members/external/check-verification-token",
        params
      ),
    {
      retry: false,
      refetchOnWindowFocus: false,
      meta: { handleError: false },
      ...config,
    }
  )
}

export function useCreateMember(
  config?: UseMutationOptions<unknown, unknown, ISendSignUpForm>
) {
  return useMutation<unknown, unknown, ISendSignUpForm>(
    (data) => api.post("operation/administration/members/external", data),
    {
      meta: { handleError: false },
      ...config,
    }
  )
}
